<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Зачем нужен таргетолог в ресторане?</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p class="text-block__text" style="margin-top:2%;">Агрегатор доставки еды Хочу Поесть предлагает Вашему вниманию полезный материал на тему «Зачем нужен таргетолог в ресторане?»</p>
            <p class="text-block__text">Не секрет, что привлекать клиента в ресторан — основная цель рекламы. </p>
            <p class="text-block__text">Таргетолог – это специалист, который занимается настройкой таргетированной рекламы в поисковых системах, социальных сетях, рекламных системах. Задача таргетолога – настроить рекламу так, чтобы она привлекала нужную аудиторию. </p>
            <p class="text-block__text" style="margin-top:2%;">Таргетологи могут работать по разным направлениям:  <br /></p>
            <p class="text-block__text"> - Реклама в социальной сети Vk.com. </p>
            <p class="text-block__text"> - Таргетированная реклама в Facebook.</p>
            <p class="text-block__text"> - Яндекс.Директ.</p>
            <p class="text-block__text"> - Google AdWords.</p>
            <p class="text-block__text"> - Таргет @Mail.ru.</p>
            <p class="text-block__text"> - Другие системы.</p>
            <p class="text-block__text"><br />Ресторану, который хочет привлекать максимальное число клиентов и увеличивать прибыль, необходим таргетолог. </p>

            <h2 class="text-block__text" style="margin-top:2%;">Где найти хорошего спеиалиста таргетолога? </h2>
            <p class="text-block__text" style="margin-top:2%;"> 1. Можно воспользоваться биржей фриланс-услуг  Kwork.</p>
            <p class="text-block__text"> 2. Найти подходящего кандидата можно по резюме на HeadHunter, SuperJob и даже Авито.</p>
            <p class="text-block__text"> 3. Спросите у знакомых и друзей, возможно среди их окружения есть подходящий вам специалист.</p>
            <p class="text-block__text" style="margin-top:2%;">Работайте  с таргетологом также, как и с остальным персоналом. Давайте четкие задачи  и требуйте отчет о проделанных действиях, ведь качественная реклама очень сильный инструмент в привлечении клиентов.</p>
            <p class="text-block__text">Надеемся, данная информация будет Вам полезной и поможет найти хорошего таргетолога для рекламы вашего заведения.</p>
            <p class="text-block__text">&nbsp;</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'targetolog'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/targetolog.vue